// extracted by mini-css-extract-plugin
export default {"root":"PlaythroughsWidget_root__2feU8","button":"PlaythroughsWidget_button__Xzerd","buttonAlt":"PlaythroughsWidget_buttonAlt__x0RPg","info":"PlaythroughsWidget_info__FEYZu"};